module.exports = __webpack_public_path__ + "files/buetti-echo.5acdc36a0113febbce3bc15cebd4ef6d.pdf";